import axiosInstance from "../../axiosInstance";

/**
 * Get Journal list for website
 * @param {*} searchKey
 * @returns
 */
const getSearchJournalArticleList = async ({ searchKey = "" }) => {
  try {
    const res = await axiosInstance.get(
      `/api/journal/websiteSearchJournalArticle?searchKey=${searchKey}`
    );

    if (res.status === 200) {
      return res.data;
    } else {
    }
  } catch (error) {}
};

export default getSearchJournalArticleList;
